<template>
  <div class="advertiser-container">
   
  </div>
</template>

<script>


export default {
  name: "Advertiser",

  data() {
    return {

    };
  },
  async created() {

  },
  methods: {
   
  },
};
</script>

<style scoped>
</style>